module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-15.7522dd0f.png";